import axios from 'axios';
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2';
import { UserContext } from '../../../Context/UserContext.js';
import ChangeUserRoleAdmin from '../ChangeUserRoleAdmin/ChangeUserRoleAdmin.jsx';

export default function SpecificUser() {
   const {id} = useParams();
   const navigate = useNavigate() ;
   const{user , setUser, role , userToken , getSpecificUser} = useContext(UserContext)
   
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function statUser (action){
      if(action === "delete"){
         Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
         }).then(async(result) => {
            if (result.isConfirmed) {

               let response =   await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/users/${id}`  , {headers:header} )
               .catch((error)=>{
                  Swal.fire({
                     title:error.response.data.message  ,
                     text: "Please Try Again" ,   
                     icon: "error"
                     });
               })
               if(response?.data.message === "success"){
                  Swal.fire({
                     title: "Deleted!",
                     text: "Your file has been deleted.",
                     icon: "success"
                  });     
                  navigate("/dashBoard/userDashboard")
               }
            }
         });
      }else{
         let response =   await axios.patch(`${process.env.REACT_APP_BASE_URL}/api/v1/users/${id}?block=${action}`  , {} ,   {headers:header} )
         .catch((error)=>{
            Swal.fire({
               title:error.response.data.message  ,
               text: "Please Try Again" ,   
               icon: "error"
               });
         })
         if(response?.data.message === "success"){
            Swal.fire({
               title:"Successfully"  ,
               text: action?  "Successfully Blocked User":  "Successfully Active User" ,   
               icon: "success"
            });
            setUser(response?.data.user)
         }
      }
   }


   useEffect(() => {
      getSpecificUser(id)
   }, [])
   

   return (
      <Fragment>
         <div className="container mt-5">
            <h1 className='main-header'>Specific User</h1>
            <div className='under-header'></div>

            <div className="row ">
               <div className="col-md-12 mb-4">
                  <h3 className='text-center'>User Information</h3>
                  <div className='border border-1 p-2 rounded-2'>
                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{user.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Age :</th>
                              <td>{user.age}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone Number :</th>
                              <td>{user.phone}</td>
                           </tr>
                           <tr>
                              <th scope="row">Email :</th>
                              <td>{user.email}</td>
                           </tr>
                           <tr>
                              <th scope="row">Role :</th>
                              <td>{user.role}</td>
                           </tr>
                           <tr>
                              <th scope="row">BirthDay :</th>
                              <td>{user.birthDay}</td>
                           </tr>
                           <tr>
                              <th scope="row">Stat :</th>
                              <td>{user.isBlocked? <p className='text-danger'>Blocked User</p>: <p className='text-success'>Active User</p>}</td>
                           </tr>
                           <tr>
                              <th scope="row">Confirm Email:</th>
                              <td>{user.confirmedEmail? <p className='text-success p-0 m-0'>Already Confirmed</p>: <p className='text-danger p-0 m-0'>Not Confirmed Please Confirmed Now</p>}</td>
                           </tr>
                        </tbody>
                     </table>
                     <div className='text-center'>
                        <button onClick={()=>{statUser(true)}} className='btn btn-sm btn-outline-primary'>Block User</button>
                        <button onClick={()=>{statUser(false)}}  className='btn btn-sm btn-outline-primary mx-2'>Active User</button>
                        <button onClick={()=>{statUser("delete")}}  className='btn btn-sm btn-outline-danger'>Delete User <i className="fa-solid fa-trash px-2"></i></button>
                        {role === "admin"? <button className="btn btn-outline-primary btn-sm d-inline-block mx-2" data-bs-toggle="modal" data-bs-target="#ChangeRoleAdmin">Update User Role <i className="fa-solid fa-pen ms-2"></i></button> :""}
                        <ChangeUserRoleAdmin/>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
